import {ApiClient as Api} from '@hconnect/apiclient'
import {useMutation, useQueryClient, type UseMutationOptions} from '@tanstack/react-query'
import {AxiosError} from 'axios'

import {prepareJobsToBeDoneInsightFormData} from '../mappers'
import {JobsToBeDoneInsightCreateDto, JobsToBeDoneInsightFormData} from '../types'

import {JobsToBeDoneQueryKey} from './useJobsToBeDone'

type CreateJobsToBeDoneInsightParams = {
  plantUpmId: string
  jobToBeDoneId: string
  activityId: string
  activityTaskId: string
}

type CreateJobsToBeDoneInsightOptions = UseMutationOptions<
  JobsToBeDoneInsightFormData,
  AxiosError,
  JobsToBeDoneInsightCreateDto
>

export const useCreateJobsToBeDoneInsight = (
  {plantUpmId, jobToBeDoneId, activityId, activityTaskId}: CreateJobsToBeDoneInsightParams,
  options?: CreateJobsToBeDoneInsightOptions
) => {
  const queryClient = useQueryClient()
  const path = `/jobs-to-be-done/api/${plantUpmId}/jobs-to-be-done/${jobToBeDoneId}/activities/${activityId}/tasks/${activityTaskId}/insights`
  const {onSuccess, onError, ...restOptions} = options ?? {}

  return useMutation<JobsToBeDoneInsightFormData, AxiosError, JobsToBeDoneInsightCreateDto>({
    mutationFn: async (data) => {
      const formData = await prepareJobsToBeDoneInsightFormData(data)

      const {data: response} = await Api.axiosInstance.post(path, formData)
      return response
    },
    onError: (error, variables, context, mutation) => {
      onError?.(error, variables, context, mutation)
    },
    onSuccess: (data, variables, context, mutation) => {
      void queryClient.invalidateQueries({queryKey: [JobsToBeDoneQueryKey]})
      onSuccess?.(data, variables, context, mutation)
    },
    ...restOptions
  })
}
